import {Map} from 'immutable';

import * as PreMatchMenuActions from 'actions/PreMatchMenu';
import * as LineActions from 'actions/Line';

export default function leaguesReducer(leagues, action) {
    switch (action.type) {
        case PreMatchMenuActions.SUCCESS_INIT_PREMATCH_MENU:
            return initMenu(leagues, action.data);

        case LineActions.CLEAR_LINE:
            return new Map();
    }

    return leagues;
}

function initMenu(leagues, data) {
    if (data === undefined) {
        return leagues;
    }

    leagues = new Map();

    if (data.leagues !== undefined) {
        leagues = addMenuLeagues(leagues, data.leagues.add);
    }

    return leagues;
}

function addMenuLeagues(leagues, addLeagues) {
    if (addLeagues === undefined) {
        return leagues;
    }

    return leagues.withMutations(l => {
        for (let i = 0; i < addLeagues.length; i++) {
            let league = new Map(addLeagues[i]);

            l.set(league.get('id'), league);
        }
    });
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/menu/leaguesReducer.js